// extracted by mini-css-extract-plugin
export default {"FAQEntry":"FAQEntry_FAQEntry__bd7oh","QuestionWrapper":"FAQEntry_QuestionWrapper__MRkyg","CloseIcon":"FAQEntry_CloseIcon__FKhIF","Answer":"FAQEntry_Answer__ffHof"};